export default "__VITE_ASSET__Cht77tV5__"